import { useState } from "react";

export const useMediaDialogs = () => {
  const [affordance, setAffordance] = useState("");
  const [isCarouselImageModal, toggleCarouselImageModal] = useState(false);
  const [isFullSizeImageModal, toggleFullSizeImageModal] = useState(false);
  const [isCarouselAlgorithmModal, toggleCarouselAlgorithmModal] = useState(
    false
  );
  const [isFullSizeAlgorithmModal, toggleFullSizeAlgorithmModal] = useState(
    false
  );
  const [isCarouselVideoModal, toggleCarouselVideoModal] = useState(false);

  const handleCarouselImageModalToggle = () => {
    toggleCarouselImageModal(!isCarouselImageModal);
  };
  const handleFullSizeImageModalToggle = () => {
    toggleFullSizeImageModal(!isFullSizeImageModal);
  };
  const handleCarouselAlgorithmModalToggle = () => {
    toggleCarouselAlgorithmModal(!isCarouselAlgorithmModal);
  };
  const handleFullSizeAlgorithmModalToggle = () => {
    toggleFullSizeAlgorithmModal(!isFullSizeAlgorithmModal);
  };

  const handleCarouselVideoModalToggle = () => {
    toggleCarouselVideoModal(!isCarouselVideoModal);
  };

  const handleAffordance = (newAffordance) => {
    setAffordance(newAffordance);
  };

  return {
    carouselImageModal: {
      carouselImageModalState: isCarouselImageModal,
      carouselImageModalHandle: handleCarouselImageModalToggle,
    },
    fullSizeImageModal: {
      fullSizeImageModalState: isFullSizeImageModal,
      fullSizeImageModalHandle: handleFullSizeImageModalToggle,
    },
    carouselAlgorithmModal: {
      carouselAlgorithmModalState: isCarouselAlgorithmModal,
      carouselAlgorithmModalHandle: handleCarouselAlgorithmModalToggle,
    },
    fullSizeAlgorithmModal: {
      fullSizeAlgorithmModalState: isFullSizeAlgorithmModal,
      fullSizeAlgorithmModalHandle: handleFullSizeAlgorithmModalToggle,
    },
    carouselVideoModal: {
      carouselVideoModalState: isCarouselVideoModal,
      carouselVideoModalHandle: handleCarouselVideoModalToggle,
    },
    affordance: {
      affordanceState: affordance,
      affordanceHandle: handleAffordance,
    },
  };
};
